import { MakePeriodDate } from "../../date";
import { COMPARE_PERIODS_ENUM } from "../../../enums/comparePeriods.enum";
import { store } from "@/store/store";

export class GMBAddressesFacadeBase {
  constructor() {
    this.period = null;
    this.isCompared = false;
    this.periodObj = null;
    this.gmbPayloadConfig = null;
    this.gmbData = null;
    this.charts = null;
  }

  async makeGMBAddresses(
    { dateFrom, dateTo, compareEnum, gmbDataEnum },
    initFacilities
  ) {
    await this._init(initFacilities);
    this._checkIsCompared(compareEnum);
    this._setPeriodObj({ dateFrom, dateTo, compareEnum });
    await this._setGmbPayloadConfig();
    await this._setGmbBuilderDirector(gmbDataEnum);
    this._setGMBCharts();
  }

  async _prepareGmbData({ groupBy, dateFrom, dateTo, compareEnum }) {
    this._checkIsCompared(compareEnum);
    this._setPeriodObj({ dateFrom, dateTo, compareEnum, groupBy });
    await this._setGmbPayloadConfig();
  }

  async exportGMBAddressesData(
    { dateFrom, dateTo, compareEnum, gmbDataEnum, groupBy },
    downloadFileExtension
  ) {
    await this._prepareGmbData({ groupBy, dateFrom, dateTo, compareEnum });
    await this._setGmbBuilderDirector(gmbDataEnum, downloadFileExtension);
  }

  async exportGMBAddressesDataAsync(
    { dateFrom, dateTo, compareEnum, gmbDataEnum, groupBy },
    downloadFileExtension
  ) {
    await this._prepareGmbData({ groupBy, dateFrom, dateTo, compareEnum });
    return this._setGmbBuilderDirectorAsync(gmbDataEnum, downloadFileExtension);
  }

  returnCharts() {
    return this.charts;
  }

  async _init(initFacilities) {
    if (initFacilities) {
      await store.dispatch("facilities/fetchAllFacilitiesIds", {
        isOwner: true
      });

      const googleAccountsIds = store.state.facilities.allFacilitiesIds.map(
        ids => ids.gmb_address_id
      );

      await store.dispatch(
        "facilities/selectFacilitiesByGmbAddressIds",
        googleAccountsIds
      );
    }

    if (!this.period) {
      this._setPeriod();
    }
  }

  _setPeriod() {
    this.period = new MakePeriodDate();
  }

  _checkIsCompared(compareEnum) {
    this.isCompared = compareEnum !== COMPARE_PERIODS_ENUM.NO_COMPARE;
  }

  _setPeriodObj({ dateFrom, dateTo, compareEnum, groupBy }) {
    if (compareEnum !== COMPARE_PERIODS_ENUM.NO_COMPARE) {
      this.period.createDateWithCompare({ dateFrom, dateTo, compareEnum });
      this.periodObj = this.period.returnPeriodWithCompare();
    } else {
      this.period.createDate({ dateFrom, dateTo });
      this.periodObj = this.period.returnPeriod();
    }
    if (groupBy) this.periodObj.group = groupBy;
  }
}
